import React from 'react';
import { solutionsHowItWorks } from '../../../shared/config/solutionsContent';

/**
 * 3-step "how it works" row (RLX-FEAT-008): Connect Jira → Get your score →
 * Decide what ships. Sits above the metro map inside the signal-layer
 * section; copy is single-sourced in `solutionsContent.ts`.
 */
export function SolutionsStepsRow(): React.ReactElement {
  return (
    <ol className="solutions-steps" aria-label={solutionsHowItWorks.heading}>
      {solutionsHowItWorks.steps.map((step, i) => (
        <li key={step.num} className="solutions-steps__item">
          <span className="solutions-steps__num" aria-hidden="true">
            {step.num}
          </span>
          <h3 className="solutions-steps__title">{step.title}</h3>
          <p className="solutions-steps__body">{step.body}</p>
          {i < solutionsHowItWorks.steps.length - 1 ? (
            <span className="solutions-steps__arrow" aria-hidden="true">
              →
            </span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
